// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qzJ8","content":"styles_content__GYnjh","tableWrap":"styles_tableWrap__12cDL"};